import React, { Component } from "react";
import styled from "styled-components";
import { TweenLite } from "gsap";

const Wrapper = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: #fc0000;
  position: relative;
  overflow: hidden;
`;

const Text = styled.div`
  font-family: "Helvetica Neue";
  font-weight: bold;
  font-size: 26px;
  width: 160px;
  height: 30px;
  color: #fff;
  letter-spacing: 0.6px;
  text-align: center;
  position: absolute;
  display: inline-block;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  z-index: 9999;
`;

const Iphone = styled.div`
  width: 292px;
  height: 610px;
  max-height: 80vh;
  max-width: calc(80vh / 2.09);
  border: 10px solid #231e1e;
  border-radius: 37px;
  position: absolute;
  overflow: hidden;
  background-color: #e1e1e1;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  opacity: 0;
`;

class Landing extends Component {
  componentDidMount() {
    this.loadGif();
  }

  loadGif = () => {
    let gif = document.createElement("img");
    gif.src = require("../assets/iphone-bg.gif");
    // gif.style.transform = "rotate(90deg)";
    gif.style.height = "100%";
    gif.style.left = 0;
    let iphone = document.querySelectorAll(".iphone")[0];
    console.log(iphone);
    gif.addEventListener("load", e => {
      iphone.appendChild(gif);
      TweenLite.to(iphone, 0.4, {
        ease: "Expo.easeInOut",
        autoAlpha: 1
      });
    });
  };

  render() {
    return (
      <Wrapper>
        <Iphone
          className="iphone"
          style={{
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            margin: "auto"
          }}
        >
          {/* <Text>Stay Tuned.</Text> */}
        </Iphone>
      </Wrapper>
    );
  }
}

export default Landing;
